(function ($) {
    $(document).ready(function() {
        let button = $('#mobile-tabs-contact');
        let contacts = $('.mt-icon');
        let contacts_container = $('.mobile-tabs-contacts');
        let phoneIcon = button.find('.phone-icon');
        let closeIcon = button.find('.close-icon');

        button.on('click', function (event) {
            event.preventDefault();
            button.toggleClass("active");
            contacts.toggleClass("active");
            contacts_container.toggleClass("active");

            phoneIcon.toggleClass('active');
            closeIcon.toggleClass('active');
        });

        $(document).on('click', function (event) {
            if (
                !$(event.target).closest(button).length &&
                !$(event.target).closest(contacts).length
            ) {
                button.removeClass("active");
                contacts.removeClass("active");
                contacts_container.removeClass("active");

                phoneIcon.addClass('active');
                closeIcon.removeClass('active');
            }
        });
    });
})(jQuery);